import React, { useEffect, useState } from "react";
import { Exercise } from "../../models/Exercise";
import useCalendarSale from "../ThreeStep/hooks/useCalendarSale";
import { useSelector } from "react-redux";
import LoadingSpinner from "../../../features/Loading/LoadingSpinner";
import { useTranslation } from "react-i18next";
import { State } from "../../store";
import EAButton from "../shared/Buttons/EAButton";
import { useMediaQuery } from "@material-ui/core";
import { HiOutlineTicket } from "react-icons/hi";
import usePreBasket from "../Universal/hooks/usePreBasket";
import useBasketManager from "../FinalizePage/hooks/useBasketManager";
import TicketLineSummary from "../Universal/TicketLineSummary";
import PreBasketSummary from "../Universal/PreBasketSummary";
import useCalculatePreBasketQnt from "../Universal/hooks/useCalculatePreBasketQnt";
import { format } from "date-fns";
import { FaMapPin, FaRegClock } from "react-icons/fa";

interface IProps {
  item: Exercise;
}

const SingleConcert: React.FC<IProps> = ({ item }: IProps) => {
  const { t } = useTranslation();
  const { getTicketsByExercise, tickets, ticketAccess } = useCalendarSale();
  const isDesktop = useMediaQuery("(min-width:900px)");
  const [open, setOpen] = useState(false);
  const { preBasket, addItemToBasket, removeItemFromBasket, clearBasket, setItemQuantity } = usePreBasket();
  const { getBasket } = useBasketManager();
  const showTicketLimits = useSelector((state: State) => state.config.configuration.showTicketsPoolForEventsSale);
  const { qntState } = useCalculatePreBasketQnt(preBasket);
  const lowestPrice = tickets.reduce((r, b) => Math.min(r, b.price), Number.POSITIVE_INFINITY);
  const [city, ...rest] = item.location.split(" ");
  const location = rest.join(" "); // Połącz resztę, jeśli są inne spacje

  const handleDeleteBasket = () => {
    clearBasket();
    setTimeout(() => {
      getBasket();
    }, 200);
  };
  useEffect(() => {
    getTicketsByExercise(item.exerciseGroup, item);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="single-concert flex-between-center border">
        <div className="left flex-start-center">
          <div className="flex-start-center">
            <FaRegClock className="single-icon" />

            <div className="single-concert-column">
              <h4> {format(item.startTime, "dd.MM.yyyy")}</h4>
              <h5> {format(item.startTime, "HH:mm")}</h5>
            </div>
          </div>
          <div className="flex-start-center single-concert-place">
            <FaMapPin className="single-icon" />
            <div className="single-concert-column">
              <h4>{city}</h4>
              <h5>{location}</h5>
            </div>
          </div>
        </div>
        <div className="right flex-end-center">
          <h5>
            {lowestPrice !== Infinity ? (
              <>
                {isDesktop ? (
                  <>
                    {t("ceny_od")} {lowestPrice} {t("zl")}
                  </>
                ) : (
                  <>
                    {t("od")} {lowestPrice} {t("zl")}
                  </>
                )}
              </>
            ) : (
              <LoadingSpinner />
            )}
          </h5>

          <div className="single-concert-button">
            <div className="capacity-procent">
              {item.reserved < item.capacity * 0.6 && <div className="status high">Duża dostępność</div>}
              {item.reserved < item.capacity * 0.6 && item.reserved > item.capacity * 0.3 && (
                <div className=" status medium">Średnia dostępność</div>
              )}
              {item.reserved > item.capacity * 0.6 && <div className=" status low">Mała dostępność</div>}
            </div>
            <EAButton
              title={!open ? t("pokaz_bilety") : t("schowaj_bilety")}
              onClick={() => setOpen(!open)}
              endIcon={<HiOutlineTicket />}
              variant={!open ? "filled" : "outlined"}
            />{" "}
          </div>
        </div>
      </div>

      {open && (
        <div className="single-event-tickets border">
          {showTicketLimits && (
            <div className="head-title flex-start-center">
              <span>
                {t("pozostalo")}:{" "}
                <b>
                  {item.capacity - item.reserved} {t("biletow")}
                </b>
              </span>
            </div>
          )}
          {item.capacity - item.reserved > 0 ? (
            <>
              {tickets.map((itemTicket, index) => (
                <div className={"ticket-block"} key={index}>
                  <TicketLineSummary
                    item={itemTicket}
                    exercise={ticketAccess}
                    preBasket={preBasket}
                    addItemToBasket={addItemToBasket}
                    removeItemFromBasket={removeItemFromBasket}
                    setItemQuantity={setItemQuantity}
                    qntState={qntState}
                    allowManualInput={true}
                  />
                </div>
              ))}
            </>
          ) : (
            <div className="alert alert-red">{t("wszystkie_bilety_zostaly_sprzedane")}</div>
          )}

          <PreBasketSummary preBasket={preBasket} clearBasket={handleDeleteBasket} />
        </div>
      )}
    </>
  );
};

export default SingleConcert;
